module.exports = __webpack_public_path__ + "static/Konditor Seite 3-ae847278a1eb59ed2dd178cdf61a5d3b.jpg";